import {
  ADDRESS_LIST_RETERIEVED,
  CARD_LIST_RETRIEVED,
  FULLSCRIPT_TREATMENTPLAN_RETRIEVED,
  CLINIC_INFO_RECEIVED,
  PATIENT_PROFILE_RECEIVED,
  PRACTITIONER_PROFILE_RECEIVED,
  USER_INFO_RECEIVED,
  PRACTITIONER_COMMISSION_RETERIEVED,
  SHIPPING_PRICE_RETRIEVED,
  QR_CODE_URL_RECEIVED,
} from "../constants/types/profileType";

const initialState = {
  clinicInfo: null,
  userInfo: null,
  addressList: [],
  cardList: [],
  patientProfile: null,
  practitionerProfile: null,
  treatmentplanList: [],
  practitionerCommission: null,
  shippingPrices: null,
  qrDetails: null,
};

export const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLINIC_INFO_RECEIVED:
      return {
        ...state,
        clinicInfo: {
          clinicId: action.payload?.CLNC_ID,
          clinicname: action.payload?.CLNC_Display,
          website: action.payload?.CLNC_URL,
          email: action.payload?.CLNC_Email,
          address_1: action.payload?.ADDR_Line_1,
          address_2: action.payload?.ADDR_Line_2,
          city: action.payload?.ADDR_Locality,
          state: action.payload?.ADDR_Region,
          phone_1: action.payload?.CLNC_Phone,
          phone_2: action.payload?.CLNC_Phone_2,
          zip: action.payload?.ADDR_Zip_Post,
          hasLogo: action.payload?.CLNC_Has_Logo,

          color_value:
            action.payload?.CLNC_Label_Value_Color == 0
              ? "#000000"
              : `#${action.payload?.CLNC_Label_Value_Color}`,
          color_headings:
            action.payload?.CLNC_Label_Heading_Color == 0
              ? "#000000"
              : `#${action.payload?.CLNC_Label_Heading_Color}`,
        },
      };

    case USER_INFO_RECEIVED: {
      return {
        ...state,
        userInfo: {
          email: action.payload.email,
          address_1: action.payload.address_1,
          address_2: action.payload.address_2,
          city: action.payload.city,
          state: action.payload.state,
          phone: action.payload.phone,
          zip: action.payload.zip,
          addressId: action.payload.address_id,
          license_agency: action.payload.PI_License_Agency,
          license_id: action.payload.PI_License_ID,
          license_description: action.payload.PI_License_Description,
          customerId: action.payload.customerId,
          file: action.payload.file,
        },
      };
    }
    case ADDRESS_LIST_RETERIEVED: {
      return {
        ...state,
        addressList: action.payload,
      };
    }
    case CARD_LIST_RETRIEVED: {
      return {
        ...state,
        cardList: action.payload,
      };
    }
    case FULLSCRIPT_TREATMENTPLAN_RETRIEVED: {
      return {
        ...state,
        treatmentplanList: action.payload,
      };
    }
    case PATIENT_PROFILE_RECEIVED: {
      return {
        ...state,
        patientProfile: action.payload,
      };
    }
    case PRACTITIONER_PROFILE_RECEIVED: {
      return {
        ...state,
        practitionerProfile: action.payload,
      };
    }
    case PRACTITIONER_COMMISSION_RETERIEVED: {
      return {
        ...state,
        practitionerCommission: action.payload,
      };
    }
    case SHIPPING_PRICE_RETRIEVED: {
      return {
        ...state,
        shippingPrices: action.payload,
      };
    }
    case QR_CODE_URL_RECEIVED: {
      return {
        ...state,
        qrDetails: action.payload,
      };
    }
    default:
      return state;
  }
};
